import * as x from "react";
import { useLayoutEffect as _e } from "react";
import { b as pt, c as bt, u as Pt } from "./index-eoE_jzLb.js";
import { P as tt, d as $e, c as Fe } from "./index-D8UDu4KA.js";
import { u as ht } from "./index-DoOsnuB6.js";
import { jsx as W } from "react/jsx-runtime";
import * as We from "react-dom";
import ke from "react-dom";
import { u as Be } from "./index-4vbonZJj.js";
function He(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = pt(t);
  x.useEffect(() => {
    const o = (r) => {
      r.key === "Escape" && n(r);
    };
    return e.addEventListener("keydown", o, { capture: !0 }), () => e.removeEventListener("keydown", o, { capture: !0 });
  }, [n, e]);
}
var Ie = "DismissableLayer", Ot = "dismissableLayer.update", ze = "dismissableLayer.pointerDownOutside", Ve = "dismissableLayer.focusOutside", Xt, ne = x.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Xe = x.forwardRef(
  (t, e) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: r,
      onFocusOutside: i,
      onInteractOutside: s,
      onDismiss: c,
      ...a
    } = t, l = x.useContext(ne), [f, p] = x.useState(null), d = (f == null ? void 0 : f.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, u] = x.useState({}), m = ht(e, (y) => p(y)), h = Array.from(l.layers), [w] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), g = h.indexOf(w), b = f ? h.indexOf(f) : -1, R = l.layersWithOutsidePointerEventsDisabled.size > 0, A = b >= g, P = Ue((y) => {
      const O = y.target, D = [...l.branches].some((C) => C.contains(O));
      !A || D || (r == null || r(y), s == null || s(y), y.defaultPrevented || c == null || c());
    }, d), v = Ke((y) => {
      const O = y.target;
      [...l.branches].some((C) => C.contains(O)) || (i == null || i(y), s == null || s(y), y.defaultPrevented || c == null || c());
    }, d);
    return He((y) => {
      b === l.layers.size - 1 && (o == null || o(y), !y.defaultPrevented && c && (y.preventDefault(), c()));
    }, d), x.useEffect(() => {
      if (f)
        return n && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (Xt = d.body.style.pointerEvents, d.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(f)), l.layers.add(f), Yt(), () => {
          n && l.layersWithOutsidePointerEventsDisabled.size === 1 && (d.body.style.pointerEvents = Xt);
        };
    }, [f, d, n, l]), x.useEffect(() => () => {
      f && (l.layers.delete(f), l.layersWithOutsidePointerEventsDisabled.delete(f), Yt());
    }, [f, l]), x.useEffect(() => {
      const y = () => u({});
      return document.addEventListener(Ot, y), () => document.removeEventListener(Ot, y);
    }, []), /* @__PURE__ */ W(
      tt.div,
      {
        ...a,
        ref: m,
        style: {
          pointerEvents: R ? A ? "auto" : "none" : void 0,
          ...t.style
        },
        onFocusCapture: bt(t.onFocusCapture, v.onFocusCapture),
        onBlurCapture: bt(t.onBlurCapture, v.onBlurCapture),
        onPointerDownCapture: bt(
          t.onPointerDownCapture,
          P.onPointerDownCapture
        )
      }
    );
  }
);
Xe.displayName = Ie;
var Ye = "DismissableLayerBranch", je = x.forwardRef((t, e) => {
  const n = x.useContext(ne), o = x.useRef(null), r = ht(e, o);
  return x.useEffect(() => {
    const i = o.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ W(tt.div, { ...t, ref: r });
});
je.displayName = Ye;
function Ue(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = pt(t), o = x.useRef(!1), r = x.useRef(() => {
  });
  return x.useEffect(() => {
    const i = (c) => {
      if (c.target && !o.current) {
        let a = function() {
          oe(
            ze,
            n,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: c };
        c.pointerType === "touch" ? (e.removeEventListener("click", r.current), r.current = a, e.addEventListener("click", r.current, { once: !0 })) : a();
      } else
        e.removeEventListener("click", r.current);
      o.current = !1;
    }, s = window.setTimeout(() => {
      e.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(s), e.removeEventListener("pointerdown", i), e.removeEventListener("click", r.current);
    };
  }, [e, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function Ke(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = pt(t), o = x.useRef(!1);
  return x.useEffect(() => {
    const r = (i) => {
      i.target && !o.current && oe(Ve, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", r), () => e.removeEventListener("focusin", r);
  }, [e, n]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function Yt() {
  const t = new CustomEvent(Ot);
  document.dispatchEvent(t);
}
function oe(t, e, n, { discrete: o }) {
  const r = n.originalEvent.target, i = new CustomEvent(t, { bubbles: !1, cancelable: !0, detail: n });
  e && r.addEventListener(t, e, { once: !0 }), o ? $e(r, i) : r.dispatchEvent(i);
}
const qe = ["top", "right", "bottom", "left"], U = Math.min, V = Math.max, ft = Math.round, lt = Math.floor, X = (t) => ({
  x: t,
  y: t
}), Ze = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function re(t, e, n) {
  return V(t, U(e, n));
}
function Y(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function K(t) {
  return t.split("-")[0];
}
function et(t) {
  return t.split("-")[1];
}
function Lt(t) {
  return t === "x" ? "y" : "x";
}
function Dt(t) {
  return t === "y" ? "height" : "width";
}
function H(t) {
  const e = t[0];
  return e === "t" || e === "b" ? "y" : "x";
}
function Tt(t) {
  return Lt(H(t));
}
function Ge(t, e, n) {
  n === void 0 && (n = !1);
  const o = et(t), r = Tt(t), i = Dt(r);
  let s = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return e.reference[i] > e.floating[i] && (s = ut(s)), [s, ut(s)];
}
function Je(t) {
  const e = ut(t);
  return [Ct(t), e, Ct(e)];
}
function Ct(t) {
  return t.includes("start") ? t.replace("start", "end") : t.replace("end", "start");
}
const jt = ["left", "right"], Ut = ["right", "left"], Qe = ["top", "bottom"], tn = ["bottom", "top"];
function en(t, e, n) {
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? Ut : jt : e ? jt : Ut;
    case "left":
    case "right":
      return e ? Qe : tn;
    default:
      return [];
  }
}
function nn(t, e, n, o) {
  const r = et(t);
  let i = en(K(t), n === "start", o);
  return r && (i = i.map((s) => s + "-" + r), e && (i = i.concat(i.map(Ct)))), i;
}
function ut(t) {
  const e = K(t);
  return Ze[e] + t.slice(e.length);
}
function on(t) {
  var e, n, o, r;
  return {
    top: (e = t.top) != null ? e : 0,
    right: (n = t.right) != null ? n : 0,
    bottom: (o = t.bottom) != null ? o : 0,
    left: (r = t.left) != null ? r : 0
  };
}
function ie(t) {
  return typeof t != "number" ? on(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function dt(t) {
  const {
    x: e,
    y: n,
    width: o,
    height: r
  } = t;
  return {
    width: o,
    height: r,
    top: n,
    left: e,
    right: e + o,
    bottom: n + r,
    x: e,
    y: n
  };
}
function Kt(t, e, n) {
  let {
    reference: o,
    floating: r
  } = t;
  const i = H(e), s = Tt(e), c = Dt(s), a = K(e), l = i === "y", f = o.x + o.width / 2 - r.width / 2, p = o.y + o.height / 2 - r.height / 2, d = o[c] / 2 - r[c] / 2;
  let u;
  switch (a) {
    case "top":
      u = {
        x: f,
        y: o.y - r.height
      };
      break;
    case "bottom":
      u = {
        x: f,
        y: o.y + o.height
      };
      break;
    case "right":
      u = {
        x: o.x + o.width,
        y: p
      };
      break;
    case "left":
      u = {
        x: o.x - r.width,
        y: p
      };
      break;
    default:
      u = {
        x: o.x,
        y: o.y
      };
  }
  const m = et(e);
  return m && (u[s] += d * (m === "end" ? 1 : -1) * (n && l ? -1 : 1)), u;
}
async function rn(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: o,
    y: r,
    platform: i,
    rects: s,
    elements: c,
    strategy: a
  } = t, {
    boundary: l = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: p = "floating",
    altBoundary: d = !1,
    padding: u = 0
  } = Y(e, t), m = ie(u), w = c[d ? p === "floating" ? "reference" : "floating" : p], g = dt(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(w))) == null || n ? w : w.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(c.floating)),
    boundary: l,
    rootBoundary: f,
    strategy: a
  })), b = p === "floating" ? {
    x: o,
    y: r,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, R = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(c.floating)), A = await (i.isElement == null ? void 0 : i.isElement(R)) && await (i.getScale == null ? void 0 : i.getScale(R)) || {
    x: 1,
    y: 1
  }, P = dt(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: c,
    rect: b,
    offsetParent: R,
    strategy: a
  }) : b);
  return {
    top: (g.top - P.top + m.top) / A.y,
    bottom: (P.bottom - g.bottom + m.bottom) / A.y,
    left: (g.left - P.left + m.left) / A.x,
    right: (P.right - g.right + m.right) / A.x
  };
}
const sn = 50, cn = async (t, e, n) => {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: i = [],
    platform: s
  } = n, c = s.detectOverflow ? s : {
    ...s,
    detectOverflow: rn
  }, a = await (s.isRTL == null ? void 0 : s.isRTL(e));
  let l = await s.getElementRects({
    reference: t,
    floating: e,
    strategy: r
  }), {
    x: f,
    y: p
  } = Kt(l, o, a), d = o, u = 0;
  const m = {};
  for (let h = 0; h < i.length; h++) {
    const w = i[h];
    if (!w)
      continue;
    const {
      name: g,
      fn: b
    } = w, {
      x: R,
      y: A,
      data: P,
      reset: v
    } = await b({
      x: f,
      y: p,
      initialPlacement: o,
      placement: d,
      strategy: r,
      middlewareData: m,
      rects: l,
      platform: c,
      elements: {
        reference: t,
        floating: e
      }
    });
    f = R ?? f, p = A ?? p, m[g] = {
      ...m[g],
      ...P
    }, v && u < sn && (u++, typeof v == "object" && (v.placement && (d = v.placement), v.rects && (l = v.rects === !0 ? await s.getElementRects({
      reference: t,
      floating: e,
      strategy: r
    }) : v.rects), {
      x: f,
      y: p
    } = Kt(l, d, a)), h = -1);
  }
  return {
    x: f,
    y: p,
    placement: d,
    strategy: r,
    middlewareData: m
  };
}, ln = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: o,
      placement: r,
      rects: i,
      platform: s,
      elements: c,
      middlewareData: a
    } = e, {
      element: l,
      padding: f = 0
    } = Y(t, e) || {};
    if (l == null)
      return {};
    const p = ie(f), d = {
      x: n,
      y: o
    }, u = Tt(r), m = Dt(u), h = await s.getDimensions(l), w = u === "y", g = w ? "top" : "left", b = w ? "bottom" : "right", R = w ? "clientHeight" : "clientWidth", A = i.reference[m] + i.reference[u] - d[u] - i.floating[m], P = d[u] - i.reference[u], v = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(l));
    let y = v ? v[R] : 0;
    (!y || !await (s.isElement == null ? void 0 : s.isElement(v))) && (y = c.floating[R] || i.floating[m]);
    const O = A / 2 - P / 2, D = y / 2 - h[m] / 2 - 1, C = U(p[g], D), F = U(p[b], D), k = y - h[m] - F, S = y / 2 - h[m] / 2 + O, T = re(C, S, k), $ = !a.arrow && et(r) != null && S !== T && i.reference[m] / 2 - (S < C ? C : F) - h[m] / 2 < 0, L = $ ? S < C ? S - C : S - k : 0;
    return {
      [u]: d[u] + L,
      data: {
        [u]: T,
        centerOffset: S - T - L,
        ...$ && {
          alignmentOffset: L
        }
      },
      reset: $
    };
  }
}), an = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: r,
        middlewareData: i,
        rects: s,
        initialPlacement: c,
        platform: a,
        elements: l
      } = e, {
        mainAxis: f = !0,
        crossAxis: p = !0,
        fallbackPlacements: d,
        fallbackStrategy: u = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: h = !0,
        ...w
      } = Y(t, e);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const g = K(r), b = H(c), R = K(c) === c, A = await (a.isRTL == null ? void 0 : a.isRTL(l.floating)), P = d || (R || !h ? [ut(c)] : Je(c)), v = m !== "none";
      !d && v && P.push(...nn(c, h, m, A));
      const y = [c, ...P], O = await a.detectOverflow(e, w), D = [];
      let C = ((o = i.flip) == null ? void 0 : o.overflows) || [];
      if (f && D.push(O[g]), p) {
        const T = Ge(r, s, A);
        D.push(O[T[0]], O[T[1]]);
      }
      if (C = [...C, {
        placement: r,
        overflows: D
      }], !D.every((T) => T <= 0)) {
        var F, k;
        const T = (((F = i.flip) == null ? void 0 : F.index) || 0) + 1, $ = y[T];
        if ($ && (!(p === "alignment" ? b !== H($) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        C.every((E) => H(E.placement) === b ? E.overflows[0] > 0 : !0)))
          return {
            data: {
              index: T,
              overflows: C
            },
            reset: {
              placement: $
            }
          };
        let L = (k = C.filter((N) => N.overflows[0] <= 0).sort((N, E) => N.overflows[1] - E.overflows[1])[0]) == null ? void 0 : k.placement;
        if (!L)
          switch (u) {
            case "bestFit": {
              var S;
              const N = (S = C.filter((E) => {
                if (v) {
                  const M = H(E.placement);
                  return M === b || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  M === "y";
                }
                return !0;
              }).map((E) => [E.placement, E.overflows.filter((M) => M > 0).reduce((M, B) => M + B, 0)]).sort((E, M) => E[1] - M[1])[0]) == null ? void 0 : S[0];
              N && (L = N);
              break;
            }
            case "initialPlacement":
              L = c;
              break;
          }
        if (r !== L)
          return {
            reset: {
              placement: L
            }
          };
      }
      return {};
    }
  };
};
function qt(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function Zt(t) {
  return qe.some((e) => t[e] >= 0);
}
const fn = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: n,
        platform: o
      } = e, {
        strategy: r = "referenceHidden",
        ...i
      } = Y(t, e);
      switch (r) {
        case "referenceHidden": {
          const s = await o.detectOverflow(e, {
            ...i,
            elementContext: "reference"
          }), c = qt(s, n.reference);
          return {
            data: {
              referenceHiddenOffsets: c,
              referenceHidden: Zt(c)
            }
          };
        }
        case "escaped": {
          const s = await o.detectOverflow(e, {
            ...i,
            altBoundary: !0
          }), c = qt(s, n.floating);
          return {
            data: {
              escapedOffsets: c,
              escaped: Zt(c)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, se = /* @__PURE__ */ new Set(["left", "top"]);
async function un(t, e) {
  const {
    placement: n,
    platform: o,
    elements: r
  } = t, i = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), s = K(n), c = et(n), a = H(n) === "y", l = se.has(s) ? -1 : 1, f = i && a ? -1 : 1, p = Y(e, t);
  let {
    mainAxis: d,
    crossAxis: u,
    alignmentAxis: m
  } = typeof p == "number" ? {
    mainAxis: p,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: p.mainAxis || 0,
    crossAxis: p.crossAxis || 0,
    alignmentAxis: p.alignmentAxis
  };
  return c && typeof m == "number" && (u = c === "end" ? m * -1 : m), a ? {
    x: u * f,
    y: d * l
  } : {
    x: d * l,
    y: u * f
  };
}
const dn = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, o;
      const {
        x: r,
        y: i,
        placement: s,
        middlewareData: c
      } = e, a = await un(e, t);
      return s === ((n = c.offset) == null ? void 0 : n.placement) && (o = c.arrow) != null && o.alignmentOffset ? {} : {
        x: r + a.x,
        y: i + a.y,
        data: {
          ...a,
          placement: s
        }
      };
    }
  };
}, mn = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: o,
        placement: r,
        platform: i
      } = e, {
        mainAxis: s = !0,
        crossAxis: c = !1,
        limiter: a = {
          fn: (b) => {
            let {
              x: R,
              y: A
            } = b;
            return {
              x: R,
              y: A
            };
          }
        },
        ...l
      } = Y(t, e), f = {
        x: n,
        y: o
      }, p = await i.detectOverflow(e, l), d = H(r), u = Lt(d);
      let m = f[u], h = f[d];
      const w = (b, R) => re(R + p[b === "y" ? "top" : "left"], R, R - p[b === "y" ? "bottom" : "right"]);
      s && (m = w(u, m)), c && (h = w(d, h));
      const g = a.fn({
        ...e,
        [u]: m,
        [d]: h
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - o,
          enabled: {
            [u]: s,
            [d]: c
          }
        }
      };
    }
  };
}, pn = function(t) {
  return t === void 0 && (t = {}), {
    options: t,
    fn(e) {
      var n, o;
      const {
        x: r,
        y: i,
        placement: s,
        rects: c,
        middlewareData: a
      } = e, {
        offset: l = 0,
        mainAxis: f = !0,
        crossAxis: p = !0
      } = Y(t, e), d = {
        x: r,
        y: i
      }, u = H(s), m = Lt(u);
      let h = d[m], w = d[u];
      const g = Y(l, e), b = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: (n = g.mainAxis) != null ? n : 0,
        crossAxis: (o = g.crossAxis) != null ? o : 0
      };
      if (f) {
        const P = m === "y" ? "height" : "width", v = c.reference[m] - c.floating[P] + b.mainAxis, y = c.reference[m] + c.reference[P] - b.mainAxis;
        h < v ? h = v : h > y && (h = y);
      }
      if (p) {
        var R, A;
        const P = m === "y" ? "width" : "height", v = se.has(K(s)), y = c.reference[u] - c.floating[P] + (v && ((R = a.offset) == null ? void 0 : R[u]) || 0) + (v ? 0 : b.crossAxis), O = c.reference[u] + c.reference[P] + (v ? 0 : ((A = a.offset) == null ? void 0 : A[u]) || 0) - (v ? b.crossAxis : 0);
        w < y ? w = y : w > O && (w = O);
      }
      return {
        [m]: h,
        [u]: w
      };
    }
  };
}, hn = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      const {
        placement: n,
        rects: o,
        platform: r,
        elements: i
      } = e, {
        apply: s = () => {
        },
        ...c
      } = Y(t, e), a = await r.detectOverflow(e, c), l = K(n), f = et(n), p = H(n) === "y", {
        width: d,
        height: u
      } = o.floating;
      let m, h;
      l === "top" || l === "bottom" ? (m = l, h = f === (await (r.isRTL == null ? void 0 : r.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (h = l, m = f === "end" ? "top" : "bottom");
      const w = u - a.top - a.bottom, g = d - a.left - a.right, b = U(u - a[m], w), R = U(d - a[h], g), A = e.middlewareData.shift, P = !A;
      let v = b, y = R;
      A != null && A.enabled.x && (y = g), A != null && A.enabled.y && (v = w), P && !f && (p ? y = d - 2 * V(a.left, a.right) : v = u - 2 * V(a.top, a.bottom)), await s({
        ...e,
        availableWidth: y,
        availableHeight: v
      });
      const O = await r.getDimensions(i.floating);
      return d !== O.width || u !== O.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function gt() {
  return typeof window < "u";
}
function nt(t) {
  return ce(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function _(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function j(t) {
  var e;
  return (e = (ce(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function ce(t) {
  return gt() ? t instanceof Node || t instanceof _(t).Node : !1;
}
function I(t) {
  return gt() ? t instanceof Element || t instanceof _(t).Element : !1;
}
function q(t) {
  return gt() ? t instanceof HTMLElement || t instanceof _(t).HTMLElement : !1;
}
function Gt(t) {
  return !gt() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof _(t).ShadowRoot;
}
function wt(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: o,
    display: r
  } = z(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + o + n) && r !== "inline" && r !== "contents";
}
function gn(t) {
  return /^(table|td|th)$/.test(nt(t));
}
function yt(t) {
  try {
    if (t.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return t.matches(":modal");
  } catch {
    return !1;
  }
}
const wn = /transform|translate|scale|rotate|perspective|filter/, yn = /paint|layout|strict|content/, Z = (t) => !!t && t !== "none";
let At;
function Mt(t) {
  const e = I(t) ? z(t) : t;
  return Z(e.transform) || Z(e.translate) || Z(e.scale) || Z(e.rotate) || Z(e.perspective) || !Nt() && (Z(e.backdropFilter) || Z(e.filter)) || wn.test(e.willChange || "") || yn.test(e.contain || "");
}
function vn(t) {
  let e = G(t);
  for (; q(e) && !rt(e); ) {
    if (Mt(e))
      return e;
    if (yt(e))
      return null;
    e = G(e);
  }
  return null;
}
function Nt() {
  return At == null && (At = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), At;
}
function rt(t) {
  return /^(html|body|#document)$/.test(nt(t));
}
function z(t) {
  return _(t).getComputedStyle(t);
}
function vt(t) {
  return I(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function G(t) {
  if (nt(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    Gt(t) && t.host || // Fallback.
    j(t)
  );
  return Gt(e) ? e.host : e;
}
function le(t) {
  const e = G(t);
  return rt(e) ? (t.ownerDocument || t).body : q(e) && wt(e) ? e : le(e);
}
function it(t, e, n) {
  var o;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const r = le(t), i = r === ((o = t.ownerDocument) == null ? void 0 : o.body), s = _(r);
  if (i) {
    const c = St(s);
    return e.concat(s, s.visualViewport || [], wt(r) ? r : [], c && n ? it(c) : []);
  } else
    return e.concat(r, it(r, [], n));
}
function St(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function ae(t) {
  const e = z(t);
  let n = parseFloat(e.width) || 0, o = parseFloat(e.height) || 0;
  const r = q(t), i = r ? t.offsetWidth : n, s = r ? t.offsetHeight : o, c = ft(n) !== i || ft(o) !== s;
  return c && (n = i, o = s), {
    width: n,
    height: o,
    $: c
  };
}
function _t(t) {
  return I(t) ? t : t.contextElement;
}
function Q(t) {
  const e = _t(t);
  if (!q(e))
    return X(1);
  const n = e.getBoundingClientRect(), {
    width: o,
    height: r,
    $: i
  } = ae(e);
  let s = (i ? ft(n.width) : n.width) / o, c = (i ? ft(n.height) : n.height) / r;
  return (!s || !Number.isFinite(s)) && (s = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: s,
    y: c
  };
}
const xn = /* @__PURE__ */ X(0);
function fe(t) {
  const e = _(t);
  return !Nt() || !e.visualViewport ? xn : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function bn(t, e, n) {
  return e === void 0 && (e = !1), !!n && e && n === _(t);
}
function J(t, e, n, o) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const r = t.getBoundingClientRect(), i = _t(t);
  let s = X(1);
  e && (o ? I(o) && (s = Q(o)) : s = Q(t));
  const c = bn(i, n, o) ? fe(i) : X(0);
  let a = (r.left + c.x) / s.x, l = (r.top + c.y) / s.y, f = r.width / s.x, p = r.height / s.y;
  if (i && o) {
    const d = _(i), u = I(o) ? _(o) : o;
    let m = d, h = St(m);
    for (; h && u !== m; ) {
      const w = Q(h), g = h.getBoundingClientRect(), b = z(h), R = g.left + (h.clientLeft + parseFloat(b.paddingLeft)) * w.x, A = g.top + (h.clientTop + parseFloat(b.paddingTop)) * w.y;
      a *= w.x, l *= w.y, f *= w.x, p *= w.y, a += R, l += A, m = _(h), h = St(m);
    }
  }
  return dt({
    width: f,
    height: p,
    x: a,
    y: l
  });
}
function xt(t, e) {
  const n = vt(t).scrollLeft;
  return e ? e.left + n : J(j(t)).left + n;
}
function ue(t, e) {
  const n = t.getBoundingClientRect(), o = n.left + e.scrollLeft - xt(t, n), r = n.top + e.scrollTop;
  return {
    x: o,
    y: r
  };
}
function An(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: o,
    strategy: r
  } = t;
  const i = r === "fixed", s = j(o), c = e ? yt(e.floating) : !1;
  if (o === s || c && i)
    return n;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = X(1);
  const f = X(0), p = q(o);
  if ((p || !i) && ((nt(o) !== "body" || wt(s)) && (a = vt(o)), p)) {
    const u = J(o);
    l = Q(o), f.x = u.x + o.clientLeft, f.y = u.y + o.clientTop;
  }
  const d = s && !p && !i ? ue(s, a) : X(0);
  return {
    width: n.width * l.x,
    height: n.height * l.y,
    x: n.x * l.x - a.scrollLeft * l.x + f.x + d.x,
    y: n.y * l.y - a.scrollTop * l.y + f.y + d.y
  };
}
function Rn(t) {
  return t.getClientRects ? Array.from(t.getClientRects()) : [];
}
function En(t) {
  const e = vt(t), n = t.ownerDocument.body, o = V(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), r = V(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let i = -e.scrollLeft + xt(t);
  const s = -e.scrollTop;
  return z(n).direction === "rtl" && (i += V(t.clientWidth, n.clientWidth) - o), {
    width: o,
    height: r,
    x: i,
    y: s
  };
}
const Pn = 25;
function On(t, e, n) {
  n === void 0 && (n = "viewport");
  const o = n === "layoutViewport", r = _(t), i = j(t), s = r.visualViewport;
  let c = i.clientWidth, a = i.clientHeight, l = 0, f = 0;
  if (s) {
    const d = !Nt() || e === "fixed";
    o ? d || (l = -s.offsetLeft, f = -s.offsetTop) : (c = s.width, a = s.height, d && (l = s.offsetLeft, f = s.offsetTop));
  }
  if (xt(i) <= 0) {
    const d = i.ownerDocument, u = d.body, m = getComputedStyle(u), h = d.compatMode === "CSS1Compat" && parseFloat(m.marginLeft) + parseFloat(m.marginRight) || 0, w = Math.abs(i.clientWidth - u.clientWidth - h), g = getComputedStyle(i).scrollbarGutter === "stable both-edges" ? w / 2 : w;
    g <= Pn && (c -= g);
  }
  return {
    width: c,
    height: a,
    x: l,
    y: f
  };
}
function Cn(t, e) {
  const n = J(t, !0, e === "fixed"), o = n.top + t.clientTop, r = n.left + t.clientLeft, i = Q(t), s = t.clientWidth * i.x, c = t.clientHeight * i.y, a = r * i.x, l = o * i.y;
  return {
    width: s,
    height: c,
    x: a,
    y: l
  };
}
function Jt(t, e, n) {
  let o;
  if (e === "viewport" || e === "layoutViewport")
    o = On(t, n, e);
  else if (e === "document")
    o = En(j(t));
  else if (I(e))
    o = Cn(e, n);
  else {
    const r = fe(t);
    o = {
      x: e.x - r.x,
      y: e.y - r.y,
      width: e.width,
      height: e.height
    };
  }
  return dt(o);
}
function Sn(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let o = it(t, [], !1).filter((c) => I(c) && nt(c) !== "body"), r = null;
  const i = z(t).position === "fixed";
  let s = i ? G(t) : t;
  for (; I(s) && !rt(s); ) {
    const c = z(s), a = Mt(s), l = r ? r.position : i ? "fixed" : "";
    !a && (l === "fixed" || l === "absolute" && c.position === "static") ? o = o.filter((p) => p !== s) : r = c, s = G(s);
  }
  return e.set(t, o), o;
}
function Ln(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: o,
    strategy: r
  } = t;
  const s = [...n === "clippingAncestors" ? yt(e) ? [] : Sn(e, this._c) : [].concat(n), o], c = Jt(e, s[0], r);
  let a = c.top, l = c.right, f = c.bottom, p = c.left;
  for (let d = 1; d < s.length; d++) {
    const u = Jt(e, s[d], r);
    a = V(u.top, a), l = U(u.right, l), f = U(u.bottom, f), p = V(u.left, p);
  }
  return {
    width: l - p,
    height: f - a,
    x: p,
    y: a
  };
}
function Dn(t) {
  const {
    width: e,
    height: n
  } = ae(t);
  return {
    width: e,
    height: n
  };
}
function Tn(t, e, n) {
  const o = q(e), r = j(e), i = n === "fixed", s = J(t, !0, i, e);
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const a = X(0);
  if ((o || !i) && ((nt(e) !== "body" || wt(r)) && (c = vt(e)), o)) {
    const d = J(e, !0, i, e);
    a.x = d.x + e.clientLeft, a.y = d.y + e.clientTop;
  }
  !o && r && (a.x = xt(r));
  const l = r && !o && !i ? ue(r, c) : X(0), f = s.left + c.scrollLeft - a.x - l.x, p = s.top + c.scrollTop - a.y - l.y;
  return {
    x: f,
    y: p,
    width: s.width,
    height: s.height
  };
}
function Rt(t) {
  return z(t).position === "static";
}
function Qt(t, e) {
  if (!q(t) || z(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let n = t.offsetParent;
  return j(t) === n && (n = n.ownerDocument.body), n;
}
function de(t, e) {
  const n = _(t);
  if (yt(t))
    return n;
  if (!q(t)) {
    let r = G(t);
    for (; r && !rt(r); ) {
      if (I(r) && !Rt(r))
        return r;
      r = G(r);
    }
    return n;
  }
  let o = Qt(t, e);
  for (; o && gn(o) && Rt(o); )
    o = Qt(o, e);
  return o && rt(o) && Rt(o) && !Mt(o) ? n : o || vn(t) || n;
}
const Mn = async function(t) {
  const e = this.getOffsetParent || de, n = this.getDimensions, o = await n(t.floating);
  return {
    reference: Tn(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function Nn(t) {
  return z(t).direction === "rtl";
}
const _n = {
  convertOffsetParentRelativeRectToViewportRelativeRect: An,
  getDocumentElement: j,
  getClippingRect: Ln,
  getOffsetParent: de,
  getElementRects: Mn,
  getClientRects: Rn,
  getDimensions: Dn,
  getScale: Q,
  isElement: I,
  isRTL: Nn
};
function me(t, e) {
  return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function $n(t, e, n) {
  let o = null, r;
  const i = j(t);
  function s() {
    var f;
    clearTimeout(r), (f = o) == null || f.disconnect(), o = null;
  }
  function c(f, p) {
    f === void 0 && (f = !1), p === void 0 && (p = 1), s();
    const d = t.getBoundingClientRect(), {
      left: u,
      top: m,
      width: h,
      height: w
    } = d;
    if (f || e(), !h || !w)
      return;
    const g = lt(m), b = lt(i.clientWidth - (u + h)), R = lt(i.clientHeight - (m + w)), A = lt(u), v = {
      rootMargin: -g + "px " + -b + "px " + -R + "px " + -A + "px",
      threshold: V(0, U(1, p)) || 1
    };
    let y = !0;
    function O(D) {
      const C = D[0].intersectionRatio;
      if (!me(d, t.getBoundingClientRect()))
        return c();
      if (C !== p) {
        if (!y)
          return c();
        C ? c(!1, C) : r = setTimeout(() => {
          c(!1, 1e-7);
        }, 1e3);
      }
      y = !1;
    }
    try {
      o = new IntersectionObserver(O, {
        ...v,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      o = new IntersectionObserver(O, v);
    }
    o.observe(t);
  }
  const a = _(t), l = () => c(n);
  return a.addEventListener("resize", l), c(!0), () => {
    a.removeEventListener("resize", l), s();
  };
}
function Fn(t, e, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: a = !1
  } = o, l = _t(t), f = r || i ? [...l ? it(l) : [], ...e ? it(e) : []] : [];
  f.forEach((g) => {
    r && g.addEventListener("scroll", n), i && g.addEventListener("resize", n);
  });
  const p = l && c ? $n(l, n, i) : null;
  let d = -1, u = null;
  s && (u = new ResizeObserver((g) => {
    let [b] = g;
    b && b.target === l && u && e && (u.unobserve(e), cancelAnimationFrame(d), d = requestAnimationFrame(() => {
      var R;
      (R = u) == null || R.observe(e);
    })), n();
  }), l && !a && u.observe(l), e && u.observe(e));
  let m, h = a ? J(t) : null;
  a && w();
  function w() {
    const g = J(t);
    h && !me(h, g) && n(), h = g, m = requestAnimationFrame(w);
  }
  return n(), () => {
    var g;
    f.forEach((b) => {
      r && b.removeEventListener("scroll", n), i && b.removeEventListener("resize", n);
    }), p == null || p(), (g = u) == null || g.disconnect(), u = null, a && cancelAnimationFrame(m);
  };
}
const Wn = dn, kn = mn, Bn = an, Hn = hn, In = fn, te = ln, zn = pn, Vn = (t, e, n) => {
  const o = /* @__PURE__ */ new Map(), r = n ?? {}, i = {
    ..._n,
    ...r.platform,
    _c: o
  };
  return cn(t, e, {
    ...r,
    platform: i
  });
};
var Xn = typeof document < "u", Yn = function() {
}, at = Xn ? _e : Yn;
function mt(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let n, o, r;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (n = t.length, n !== e.length) return !1;
      for (o = n; o-- !== 0; )
        if (!mt(t[o], e[o]))
          return !1;
      return !0;
    }
    if (r = Object.keys(t), n = r.length, n !== Object.keys(e).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(e, r[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const i = r[o];
      if (!(i === "_owner" && t.$$typeof) && !mt(t[i], e[i]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function pe(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function ee(t, e) {
  const n = pe(t);
  return Math.round(e * n) / n;
}
function Et(t) {
  const e = x.useRef(t);
  return at(() => {
    e.current = t;
  }), e;
}
function jn(t) {
  t === void 0 && (t = {});
  const {
    placement: e = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: r,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: c = !0,
    whileElementsMounted: a,
    open: l
  } = t, [f, p] = x.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [d, u] = x.useState(o);
  mt(d, o) || u(o);
  const [m, h] = x.useState(null), [w, g] = x.useState(null), b = x.useCallback((E) => {
    E !== v.current && (v.current = E, h(E));
  }, []), R = x.useCallback((E) => {
    E !== y.current && (y.current = E, g(E));
  }, []), A = i || m, P = s || w, v = x.useRef(null), y = x.useRef(null), O = x.useRef(f), D = a != null, C = Et(a), F = Et(r), k = Et(l), S = x.useCallback(() => {
    if (!v.current || !y.current)
      return;
    const E = {
      placement: e,
      strategy: n,
      middleware: d
    };
    F.current && (E.platform = F.current), Vn(v.current, y.current, E).then((M) => {
      const B = {
        ...M,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: k.current !== !1
      };
      T.current && !mt(O.current, B) && (O.current = B, We.flushSync(() => {
        p(B);
      }));
    });
  }, [d, e, n, F, k]);
  at(() => {
    l === !1 && O.current.isPositioned && (O.current.isPositioned = !1, p((E) => ({
      ...E,
      isPositioned: !1
    })));
  }, [l]);
  const T = x.useRef(!1);
  at(() => (T.current = !0, () => {
    T.current = !1;
  }), []), at(() => {
    if (A && (v.current = A), P && (y.current = P), A && P) {
      if (C.current)
        return C.current(A, P, S);
      S();
    }
  }, [A, P, S, C, D]);
  const $ = x.useMemo(() => ({
    reference: v,
    floating: y,
    setReference: b,
    setFloating: R
  }), [b, R]), L = x.useMemo(() => ({
    reference: A,
    floating: P
  }), [A, P]), N = x.useMemo(() => {
    const E = {
      position: n,
      left: 0,
      top: 0
    };
    if (!L.floating)
      return E;
    const M = ee(L.floating, f.x), B = ee(L.floating, f.y);
    return c ? {
      ...E,
      transform: "translate(" + M + "px, " + B + "px)",
      ...pe(L.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: M,
      top: B
    };
  }, [n, c, L.floating, f.x, f.y]);
  return x.useMemo(() => ({
    ...f,
    update: S,
    refs: $,
    elements: L,
    floatingStyles: N
  }), [f, S, $, L, N]);
}
const Un = (t) => {
  function e(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: t,
    fn(n) {
      const {
        element: o,
        padding: r
      } = typeof t == "function" ? t(n) : t;
      return o && e(o) ? o.current != null ? te({
        element: o.current,
        padding: r
      }).fn(n) : {} : o ? te({
        element: o,
        padding: r
      }).fn(n) : {};
    }
  };
}, Kn = (t, e) => {
  const n = Wn(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, qn = (t, e) => {
  const n = kn(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, Zn = (t, e) => ({
  fn: zn(t).fn,
  options: [t, e]
}), Gn = (t, e) => {
  const n = Bn(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, Jn = (t, e) => {
  const n = Hn(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, Qn = (t, e) => {
  const n = In(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, to = (t, e) => {
  const n = Un(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
};
var eo = "Arrow", he = x.forwardRef((t, e) => {
  const { children: n, width: o = 10, height: r = 5, ...i } = t;
  return /* @__PURE__ */ W(
    tt.svg,
    {
      ...i,
      ref: e,
      width: o,
      height: r,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: t.asChild ? n : /* @__PURE__ */ W("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
he.displayName = eo;
var no = he, $t = "Popper", [ge, vo] = Fe($t), [oo, we] = ge($t), ye = (t) => {
  const { __scopePopper: e, children: n } = t, [o, r] = x.useState(null);
  return /* @__PURE__ */ W(oo, { scope: e, anchor: o, onAnchorChange: r, children: n });
};
ye.displayName = $t;
var ve = "PopperAnchor", xe = x.forwardRef(
  (t, e) => {
    const { __scopePopper: n, virtualRef: o, ...r } = t, i = we(ve, n), s = x.useRef(null), c = ht(e, s);
    return x.useEffect(() => {
      i.onAnchorChange((o == null ? void 0 : o.current) || s.current);
    }), o ? null : /* @__PURE__ */ W(tt.div, { ...r, ref: c });
  }
);
xe.displayName = ve;
var Ft = "PopperContent", [ro, io] = ge(Ft), be = x.forwardRef(
  (t, e) => {
    var Wt, kt, Bt, Ht, It, zt;
    const {
      __scopePopper: n,
      side: o = "bottom",
      sideOffset: r = 0,
      align: i = "center",
      alignOffset: s = 0,
      arrowPadding: c = 0,
      avoidCollisions: a = !0,
      collisionBoundary: l = [],
      collisionPadding: f = 0,
      sticky: p = "partial",
      hideWhenDetached: d = !1,
      updatePositionStrategy: u = "optimized",
      onPlaced: m,
      ...h
    } = t, w = we(Ft, n), [g, b] = x.useState(null), R = ht(e, (ot) => b(ot)), [A, P] = x.useState(null), v = Be(A), y = (v == null ? void 0 : v.width) ?? 0, O = (v == null ? void 0 : v.height) ?? 0, D = o + (i !== "center" ? "-" + i : ""), C = typeof f == "number" ? f : { top: 0, right: 0, bottom: 0, left: 0, ...f }, F = Array.isArray(l) ? l : [l], k = F.length > 0, S = {
      padding: C,
      boundary: F.filter(co),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: k
    }, { refs: T, floatingStyles: $, placement: L, isPositioned: N, middlewareData: E } = jn({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: D,
      whileElementsMounted: (...ot) => Fn(...ot, {
        animationFrame: u === "always"
      }),
      elements: {
        reference: w.anchor
      },
      middleware: [
        Kn({ mainAxis: r + O, alignmentAxis: s }),
        a && qn({
          mainAxis: !0,
          crossAxis: !1,
          limiter: p === "partial" ? Zn() : void 0,
          ...S
        }),
        a && Gn({ ...S }),
        Jn({
          ...S,
          apply: ({ elements: ot, rects: Vt, availableWidth: De, availableHeight: Te }) => {
            const { width: Me, height: Ne } = Vt.reference, ct = ot.floating.style;
            ct.setProperty("--radix-popper-available-width", `${De}px`), ct.setProperty("--radix-popper-available-height", `${Te}px`), ct.setProperty("--radix-popper-anchor-width", `${Me}px`), ct.setProperty("--radix-popper-anchor-height", `${Ne}px`);
          }
        }),
        A && to({ element: A, padding: c }),
        lo({ arrowWidth: y, arrowHeight: O }),
        d && Qn({ strategy: "referenceHidden", ...S })
      ]
    }), [M, B] = Ee(L), st = pt(m);
    Pt(() => {
      N && (st == null || st());
    }, [N, st]);
    const Pe = (Wt = E.arrow) == null ? void 0 : Wt.x, Oe = (kt = E.arrow) == null ? void 0 : kt.y, Ce = ((Bt = E.arrow) == null ? void 0 : Bt.centerOffset) !== 0, [Se, Le] = x.useState();
    return Pt(() => {
      g && Le(window.getComputedStyle(g).zIndex);
    }, [g]), /* @__PURE__ */ W(
      "div",
      {
        ref: T.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...$,
          transform: N ? $.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: Se,
          "--radix-popper-transform-origin": [
            (Ht = E.transformOrigin) == null ? void 0 : Ht.x,
            (It = E.transformOrigin) == null ? void 0 : It.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((zt = E.hide) == null ? void 0 : zt.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: t.dir,
        children: /* @__PURE__ */ W(
          ro,
          {
            scope: n,
            placedSide: M,
            onArrowChange: P,
            arrowX: Pe,
            arrowY: Oe,
            shouldHideArrow: Ce,
            children: /* @__PURE__ */ W(
              tt.div,
              {
                "data-side": M,
                "data-align": B,
                ...h,
                ref: R,
                style: {
                  ...h.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: N ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
be.displayName = Ft;
var Ae = "PopperArrow", so = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Re = x.forwardRef(function(e, n) {
  const { __scopePopper: o, ...r } = e, i = io(Ae, o), s = so[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ W(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ W(
          no,
          {
            ...r,
            ref: n,
            style: {
              ...r.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Re.displayName = Ae;
function co(t) {
  return t !== null;
}
var lo = (t) => ({
  name: "transformOrigin",
  options: t,
  fn(e) {
    var w, g, b;
    const { placement: n, rects: o, middlewareData: r } = e, s = ((w = r.arrow) == null ? void 0 : w.centerOffset) !== 0, c = s ? 0 : t.arrowWidth, a = s ? 0 : t.arrowHeight, [l, f] = Ee(n), p = { start: "0%", center: "50%", end: "100%" }[f], d = (((g = r.arrow) == null ? void 0 : g.x) ?? 0) + c / 2, u = (((b = r.arrow) == null ? void 0 : b.y) ?? 0) + a / 2;
    let m = "", h = "";
    return l === "bottom" ? (m = s ? p : `${d}px`, h = `${-a}px`) : l === "top" ? (m = s ? p : `${d}px`, h = `${o.floating.height + a}px`) : l === "right" ? (m = `${-a}px`, h = s ? p : `${u}px`) : l === "left" && (m = `${o.floating.width + a}px`, h = s ? p : `${u}px`), { data: { x: m, y: h } };
  }
});
function Ee(t) {
  const [e, n = "center"] = t.split("-");
  return [e, n];
}
var xo = ye, bo = xe, Ao = be, Ro = Re, ao = "Portal", fo = x.forwardRef((t, e) => {
  var c;
  const { container: n, ...o } = t, [r, i] = x.useState(!1);
  Pt(() => i(!0), []);
  const s = n || r && ((c = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : c.body);
  return s ? ke.createPortal(/* @__PURE__ */ W(tt.div, { ...o, ref: e }), s) : null;
});
fo.displayName = ao;
export {
  Ro as A,
  Ao as C,
  Xe as D,
  fo as P,
  xo as R,
  bo as a,
  vo as c
};
